export default {
  app: {
    featured: 'Aanbevolen',
    random: 'Willekeurig',
    explore: 'Alle recepten',
    keywords: 'Trefwoorden',
    search: 'Zoeken',
  },
  explore: {
    filters: 'Filters',
    resetFilters: 'Filters resetten',
    addKeyword: 'Trefwoord toevoegen',
  },
  recipe: {
    contributedBy: 'Bijdrage door',
    ingredients: 'Ingrediënten',
    directions: 'Bereidingswijze',
    fullRecipe: 'Bekijk het volledige recept op',
    similarDrinks: 'Vergelijkbare drankjes',
  },
  featuredRecipes: {
    loadMore: 'Laad meer',
  },
  recipeFind: {
    filterBy: 'Filter op',
    name: 'Naam',
    ingredients: 'Ingrediënten',
    keywords: 'Trefwoorden',
    searchForIngredients:
      'Je kunt zoeken op meerdere ingrediënten door ze met een spatie te scheiden',
    searchForKeywords: 'Je kunt zoeken op meerdere trefwoorden door ze met een spatie te scheiden',
  },
  recipeList: {
    viewRecipe: 'Recept bekijken',
  },
  recipeToolbar: {
    print: 'Printen',
    share: 'Delen',
    shareOnFacebook: 'Deel op Facebook',
    shareOnTwitter: 'Deel op Twitter',
    copyURL: 'URL kopiëren',
    hideImage: 'Afbeelding verbergen',
  },
  favorites: {
    removeAllFavorites: 'Alle favorieten verwijderen',
    noFavoriteDrinks: 'Je hebt nog geen favoriete drankjes',
    removeFavoritesPrompt: 'Weet je zeker dat je al je favorieten wilt verwijderen?',
    delete: 'Verwijderen',
    cancel: 'Annuleren',
  },
  keywordList: {
    enterYourKeyword: 'Voer uw trefwoord in',
  },
  search: {
    findYourDrink: 'Vind jouw drankje',
  },
  pageNotFound: {
    pageNotFound: 'Deze pagina is niet beschikbaar.',
    backToHome: 'Naar de homepage',
  },
};
